<div
  *ngIf="aemConfigurableData"
  attr.pdlPageComponentId="{{ pdlPageComponentId }}"
  attr.pdlRepeatedComponent="{{ pdlRepeatedComponent }}"
>
  <h3 class="m-t-xl m-l-sm inline-block">{{ category }}</h3>
  <div class="inline-block m-l-sm" *ngIf="hardGoods?.length > 0">
    <p>
      <span> ({{ hardGoods?.length }} of {{ deviceCount }})</span>
    </p>
  </div>
  <div *ngFor="let hardgood of hardGoods; let idx = index">
    <div *ngIf="idx % 3 == 0" class="row m-t-xl">
      <div
        *ngFor="let hardgood of hardGoods | loopUnroll: idx : 3"
        class="col-12 col-md-4 text-center"
        id="product-{{ hardgood?.offerId }}"
      >
        <tmo-browse-hardgood
          [isSearchedProduct]="false"
          [hardgoodData]="hardgood"
          [contentData]="aemConfigurableData"
        ></tmo-browse-hardgood>
      </div>
    </div>
    <div *ngIf="idx % 3 == 0" class="d-none d-md-block">
      <!-- Disclaimer on every row -->
      <div class="row m-t-xl" *ngIf="false">
        <div class="col-12 text-center">
          <p class="legal">{{ aemConfigurableData?.disclaimer }}</p>
        </div>
      </div>
      <!-- Divider after every row -->
      <div class="row m-t-lg">
        <div class="col-12">
          <hr class="divider" />
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="showErrorMessage">
    <tmo-error-message-detail
      [errorText]="aemConfigurableData?.problemRetrievingAccessories"
    ></tmo-error-message-detail>
  </div>
  <!-- No Results Found -->
  <div class="col-12 m-t-lg" *ngIf="hardGoods?.length === 0">
    <p>{{ aemConfigurableData?.noResultsFound }}</p>
  </div>
  <div class="col-12 button-spacing">
    <tmo-button
      [button]="seeMore"
      (onSelect)="onClickSeeAll()"
      id="tmo-button-next-btn"
      [disabled]="!isProductAvailable"
      >{{ aemConfigurableData?.seeMore }}</tmo-button
    >
  </div>
</div>

<!-- Spinner -->
<div *ngIf="hardGoods?.length === 0">
  <tmo-spinner [setDelay]="hardGoods?.length > 0"></tmo-spinner>
</div>
<div class="row">
  <div *ngIf="showComponentSpinner" class="col-6">
    <tmo-inline-spinner class="pull-right" [setDelay]="!showComponentSpinner"></tmo-inline-spinner>
  </div>
</div>
